import React, { useEffect, useState } from 'react';
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";

const imagePath = "https://sms.cooledsys.com/aboutStudentHpc.jpg";

const AboutStudent = ({ aboutStudent, generalInfo, partAColor }) => {

    const [student, setStudent] = useState("");
    const [age, setAge] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [favouriteFood, setFavouriteFood] = useState("pizza, pasta, and homemade biryani, burgur, chilli potato, garlic bread the most.");
    const [favouriteGames, setFavouriteGames] = useState("Football, chess, and video games keep me entertained.");
    const [favouriteFestivals, setFavouriteFestivals] = useState("Diwali, Holi, and Christmas are my favorite celebrations.");
    const [goodAt, setGoodAt] = useState("drawing, singing, and solving puzzles.");
    const [notGoodAt, setNotGoodAt] = useState("Math, public speaking.");
    const [likeToImprove, setLikeToImprove] = useState("handwriting and communication skills.");
    const [like, setLike] = useState("painting, reading books, and exploring new places.");
    const [dontLike, setDontLike] = useState("waking up early or doing difficult math.");
    const [ambition, setAmbition] = useState("become a scientist and invent useful things. become a scientist and invent useful things. become a scientist and invent useful things.");
    const [myIdol, setMyIdol] = useState("Elon Musk because he inspires innovation.");
    const [lstThingsLearn, setLstThingsLearn] = useState([
        "playing the guitar and singing playing the guitar and singing",
        "solving complex puzzles and riddles",
        "learning new languages and cultures"
      ]);
      




    useEffect(() => {
        // console.log("AboutStudent called generalInfo", generalInfo);
        if (generalInfo) {
            setStudent(generalInfo.student);
            setAge(generalInfo.age);
            setImageUrl(generalInfo.photo);
        }
    }, [generalInfo]);

    useEffect(() => {
        // console.log("AboutStudent called aboutStudent", aboutStudent);
    }, []);



    const RoundBox = ({ title }) =>
        <View
            style={{
                flexDirection: 'column',
                flex: 25, border: '2px solid darkorange',
                borderRadius: 6,
                height: 80,
                width: 'auto',
                backgroundColor: '#fdeada'
            }}
        >
            <Text style={styles.header2}>{title}</Text>
        </View>;
    const SectionTitle = ({ title, color, bgColor, borderColor }) =>
        <Text style={[styles.header2, { backgroundColor: bgColor, color: color, borderColor: borderColor }]}>{title}</Text>
    const PartHeader = ({ title }) =>
        <Text style={styles.header1}>{title}</Text>;
    const SubHeader = ({ subTitle }) =>
        <Text style={styles.header2}>{subTitle}</Text>;


    const stylePage = StyleSheet.create({
        page: {
            position: "relative",
            fontSize: 12,
            padding: 20,
            backgroundColor: partAColor//"#5e35b1",
        }
    });

    return (
        <Page style={[stylePage.page, styles.bgPartA2]}>
            <View >
                <PartHeader title="Part A(2)" />
                {<SubHeader subTitle="All About Me!" />}
                <View style={styles.sectionContainer}>
                    <View style={[styles.imageSection]}>
                        < View style={styles.imageContainer}>
                            <Image src={imagePath} style={styles.backgroundImage} />
                            <View style={styles.overlayStudentName}>
                                <Text style={styles.textStudentName}>{student}</Text>
                            </View>
                            <View style={styles.overlayStudentAge}>
                                <Text style={styles.textStudentAge}>{age}</Text>
                            </View>
                            <View style={styles.overlayStudentImage}>
                                <Image src={imageUrl} style={styles.studentImage} />
                            </View>
                            <View style={styles.overlayStudentAge}>
                                <Text style={styles.textStudentAge}>{age}</Text>
                            </View>
                            <View style={styles.overlayDontLike}>
                                <Text style={styles.textDontLike}>{dontLike}</Text>
                            </View>
                            <View style={styles.overlayLike}>
                                <Text style={styles.textLike}>{like}</Text>
                            </View>
                            <View style={styles.overlayLikeToImprove}>
                                <Text style={styles.textLikeToImprove}>{likeToImprove}</Text>
                            </View>
                            <View style={styles.overlayNotGoodAt}>
                                <Text style={styles.textNotGoodAt}>{notGoodAt}</Text>
                            </View>
                            <View style={styles.overlayGoodAt}>
                                <Text style={styles.textGoodAt}>{goodAt}</Text>
                            </View>
                            <View style={styles.overlayFood}>
                                <Text style={styles.textFood}>
                                    {"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" + favouriteFood}
                                    </Text>
                            </View>
                            <View style={styles.overlayGames}>
                                <Text style={styles.textGames}>
                                    {"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" + favouriteGames}
                                    </Text>
                            </View>
                            <View style={styles.overlayFestival}>
                                <Text style={styles.textFestival}>
                                    {"\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0" + favouriteFestivals}
                                    </Text>
                            </View>
                            <View style={styles.overlayWantToBe}>
                                <Text style={styles.textWantToBe}>{ambition}</Text>
                            </View>
                            <View style={styles.overlayIdeal}>
                                <Text style={styles.textIdeal}>{myIdol}</Text>
                            </View>
                            <View style={styles.overlayLearning1}>
                                <Text style={styles.textLearning1}>{"\u00A0" + lstThingsLearn[0]}</Text>
                            </View>
                            <View style={styles.overlayLearning2}>
                                <Text style={styles.textLearning2}>{"\u00A0" + lstThingsLearn[1]}</Text>
                            </View>
                            <View style={styles.overlayLearning3}>
                                <Text style={styles.textLearning3}>{"\u00A0" + lstThingsLearn[2]}</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        </Page>
    );
}
export default AboutStudent;

const styles = StyleSheet.create({
    header1: {
        fontSize: 16,
        fontWeight: "bold",
        textAlign: 'center',
        textTransform: 'uppercase',
        color: '#e36c0a',
        fontFamily: 'Helvetica-Bold',
        // borderRadius: 6,
        padding: 10,
        paddingTop: 30
    }, header2: {
        fontSize: 12,
        fontWeight: "bold",
        textAlign: 'center',
        textTransform: 'capitalize',
        fontFamily: 'Helvetica-Bold',
        color: '#000',
        // borderRadius: 6,
        padding: 5
    },
    bgPartA2: {
        backgroundColor: '#fff'//'#fee4a4'
    },
    sectionContainer: {
        flexDirection: 'column',
    },
    imageSection: {
        width: "100%",
        // flexDirection: "row",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        // border: '1px solid blue',
    },
    imageContainer: {
        width: "100%",
        height: "700px",
        // border: '1px solid green',
        position: 'relative',
    },
    studentImage: {
        position: 'absolute',
        width: "100%",
        height: "100%",
        // objectFit:"contain",
        // height: "400px",
    },
    overlayStudentName: {
        position: 'absolute',
        marginTop: 63,
        marginLeft: 43,
        height: 20,
        width: 152,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid black',
    },
    textStudentName: {
        fontSize: 14,
        textAlign: 'center',
        // marginBottom: 5,
    },
    textStudentAge: {
        fontSize: 14,
        textAlign: 'center',
        // marginBottom: 5,
    },
    overlayStudentImage: {
        position: 'absolute',
        marginTop: 70,
        marginLeft: 320,
        height: 100,
        width: 150,
        // padding: 10,
        borderRadius: 5,
        border: '1px solid black',
        transform: 'rotate(-2deg)'
    },
    overlayStudentAge: {
        position: 'absolute',
        marginTop: 99,
        marginLeft: 81,
        height: 20,
        width: 50,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid black',
    },
    overlayFavouriteFood: {
        position: 'absolute',
        marginTop: 99,
        marginLeft: 81,
        height: 20,
        width: 50,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid black',
    },
    overlayFavouriteGames: {
        position: 'absolute',
        marginTop: 99,
        marginLeft: 81,
        height: 20,
        width: 50,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid black',
    },
    overlayFavouriteFestivals: {
        position: 'absolute',
        marginTop: 99,
        marginLeft: 81,
        height: 20,
        width: 50,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid black',
    },
    overlayDontLike: {
        position: 'absolute',
        marginTop: 320,
        marginLeft: 163,
        height: 20,
        width: 120,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
        transform: 'rotate(104deg)'
    },
    textDontLike: {
        fontSize: 10,
        textAlign: 'left',
        // marginBottom: 5,
    },
    overlayLike: {
        position: 'absolute',
        marginTop: 265,
        marginLeft: 135,
        height: 20,
        width: 130,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
        transform: 'rotate(99deg)'
    },
    textLike: {
        fontSize: 10,
        textAlign: 'left',
        // marginBottom: 5,
    },
    overlayLikeToImprove: {
        position: 'absolute',
        marginTop: 340,
        marginLeft: 140,
        height: 20,
        width: 50,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
        transform: 'rotate(89deg)'
    },
    textLikeToImprove: {
        fontSize: 10,
        textAlign: 'left',
        // marginBottom: 5,
    },
    overlayNotGoodAt: {
        position: 'absolute',
        marginTop: 305,
        marginLeft: 88,
        height: 20,
        width: 90,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
        transform: 'rotate(73deg)'
    },
    textNotGoodAt: {
        fontSize: 10,
        textAlign: 'left',
        // marginBottom: 5,
    },
    overlayGoodAt: {
        position: 'absolute',
        marginTop: 350,
        marginLeft: 76,
        height: 20,
        width: 100,
        // padding: 10,
        borderRadius: 5,
        // border: '1px solid green',
        transform: 'rotate(47deg)'
    },
    textGoodAt: {
        fontSize: 10,
        textAlign: 'left',
        // marginBottom: 5,
    },
    overlayFood: {
        position: 'absolute',
        marginTop: 238,
        marginLeft: 325,
        height: 60,
        width: 155,
        padding: 2,
        borderRadius: 5,
        // border: '1px solid green',
    },
    textFood: {
        fontSize: 11,
        textAlign: 'left',
        lineHeight: 1.4,
        // marginBottom: 5,
    },
    overlayGames: {
        position: 'absolute',
        marginTop: 313,
        marginLeft: 325,
        height: 60,
        width: 155,
        padding: 2,
        borderRadius: 5,
        // border: '1px solid green',
    },
    textGames: {
        fontSize: 11,
        textAlign: 'left',
        lineHeight: 1.4,
        // marginBottom: 5,
    },
    overlayFestival: {
        position: 'absolute',
        marginTop: 388,
        marginLeft: 325,
        height: 60,
        width: 155,
        padding: 2,
        borderRadius: 5,
        // border: '1px solid green',
    },
    textFestival: {
        fontSize: 11,
        textAlign: 'left',
        lineHeight: 1.4,
        // marginBottom: 5,
    },
    overlayWantToBe: {
        position: 'absolute',
        marginTop: 500,
        marginLeft: 73,
        height: 50,
        width: 115,
        padding: 2,
        borderRadius: 5,
        // border: '1px solid green',
    },
    textWantToBe: {
        fontSize: 10,
        textAlign: 'left',
        lineHeight: 1.3,
        // marginBottom: 5,
    },
    overlayIdeal:{
        position: 'absolute',
        marginTop: 648,
        marginLeft: 20,
        height: 30,
        width: 180,
        padding: 2,
        borderRadius: 5,
        // border: '1px solid green',
    },
    textIdeal:{
        fontSize: 11,
        textAlign: 'left',
        lineHeight: 1.3,
        // marginBottom: 5,
    },
    overlayLearning1:{
        position: 'absolute',
        marginTop: 545,
        marginLeft: 308,
        height: 40,
        width: 140,
        padding: 2,
        borderRadius: 5,
        // border: '1px solid green',
    },
    textLearning1:{
        fontSize: 10,
        textAlign: 'left',
        lineHeight: 1.5,
    },
    overlayLearning2:{
        position: 'absolute',
        marginTop: 580,
        marginLeft: 308,
        height: 40,
        width: 140,
        padding: 2,
        borderRadius: 5,
        // border: '1px solid green',
    },
    textLearning2:{
        fontSize: 10,
        textAlign: 'left',
        lineHeight: 1.5,
    },
    overlayLearning3:{
        position: 'absolute',
        marginTop: 615,
        marginLeft: 308,
        height: 40,
        width: 140,
        padding: 2,
        borderRadius: 5,
        // border: '1px solid green',
    },
    textLearning3:{
        fontSize: 10,
        textAlign: 'left',
        lineHeight: 1.5,
    },
});